import React, { useEffect, useState } from "react";
import { hasOwn, mapArrayToObject } from "../../../commonFunctions/arrayFunc";
import fileFolderConfig, { extractVariables } from "../../../commonFunctions/fileFolderConfig";
import { useTableContext } from "../../../context/TableContext";
import BuilderModal from "../../../Layouts/Modal/BuilderModal";
import { getFieldIcon } from "../../../utils/getFieldIcon";
import { isValidObjectId } from "../../../utils/objectIdUtils";
import Input from "../../FormComponents/Input";
import Textarea from "../../FormComponents/Textarea";
import Tree from "../../SideBar/Tree";
import FromTokenDropdown from "../FromTokenDropdown";
import MaterialIcon from "../MaterialIcon";
import TableTreeModal from "../TableTreeModal";
import { VariableMappingReadOnly } from "./JobReadOnly";
import { EMAIL_RESULT_FIELDS, getDefaultTypeOfMapping, getLabelNameForTheJobMapping, getTypeOptions } from "./Utils";
import { getToolTipAttributes } from "../../../utils/tooltip";
import axiosInstance from "../../../services/axiosService";
import SetGlobalVariablesPlugin from "./plugins/SetGlobalVariablesPlugin";

const GetVariableMapping = ({
  keyName,
  params,
  setParams,
  smId,
  handleParamsData,
  allFieldsObject,
  isReadOnly,
  templateObject,
  editJobData,
  getTemplateData,
  jobTemplateName,
  getAppUserFieldsData,
  preRequirements,
  actId,
  type
}) => {
  const { getSingleTableData, getTableTypeData } = useTableContext();

  // const getCommunityUserData = async () => {
  //   try {
  //     const { data } = await axiosInstance.get(`/communityUserConfig`);
  //     let array = data.fields || [];
  //     // array = [{ id: "target_user", field_type: "target_user" }, ...array];
  //     const { result: fieldObject } = mapArrayToObject(array);
  //     allFieldsObject.current = { ...allFieldsObject.current, ...fieldObject };
  //     return array;
  //   } catch (error) {
  //     return [];
  //   }
  // };

  const filterMapping = (newObj, mapArr) => {
    const paramMapping = editJobData?.params?.[keyName] || [];

    // Convert param array to object keyed by `key`
    if (paramMapping.length) {
      newObj = paramMapping.reduce((acc, variable) => {
        acc[variable.key] = variable;
        return acc;
      }, {});
    }

    const newDataArray =
      mapArr?.map((field) => {
        const newField = hasOwn(field, "id") ? field.id : field.name || field;
        if (newObj[newField]) {
          return newObj[newField];
        }
        return {
          key: newField,
          value: "",
          type: getDefaultTypeOfMapping(field.field_type, jobTemplateName)
        };
      }) || [];

    if (
      keyName === "body_variable_mapping" ||
      keyName === "header_variable_mapping" ||
      keyName === "url_variable_mapping" ||
      keyName === "statechange_on_error" ||
      keyName === "output_variable_mapping" ||
      keyName === "variable_mapping" ||
      keyName === "self_global_variable_mapping" ||
      keyName === "grid_json_variable_mapping"
    ) {
      const paramArray = Array.isArray(params?.[keyName]) ? params[keyName] : [];

      const paramMap = paramArray.reduce((acc, item) => {
        if (item && typeof item.key === "string") {
          acc[item.key] = item;
        }
        return acc;
      }, {});

      return Array.isArray(newDataArray)
        ? newDataArray.map((item) => {
            if (item && typeof item.key === "string" && paramMap[item.key]) {
              return { ...paramMap[item.key] };
            }
            return item;
          })
        : [];
    }

    return newDataArray;
  };

  const makeParamsArray = async (newObj, templateName) => {
    let selectedSm = {};
    let newSmId = params.sm_id || params.entity_id || smId;
    let newType = params.sm_id || params.entity_id ? "statemachine" : type;
    const { data, tableObject } = await getTableTypeData(newType, newSmId);

    selectedSm = data;

    allFieldsObject.current = { ...allFieldsObject.current, ...tableObject };
    let allFields = [];
    switch (templateName) {
      case "perform_activity_bg":
      case "perform_activity":
      case "perform_activity_rdbms_fe":
        const actData = getTemplateData("activity_id");
        let fields = actData.find((act) => act.activity_id === params["activity_id"]).items;
        if (templateName === "perform_activity_rdbms_fe") {
          fields = ["instance_id", ...fields];
        }
        allFields = fields;
        break;

      case "register_entity":
      case "edit_entity_fe":
      case "register_entity_bg":
        const initFieldsOfEntity = data.table.columns_new.find(
          (row) => row.type === "activity" && row.activity_type === "init"
        ).items;
        allFields = ["instance_id", ...initFieldsOfEntity];
        break;
      case "start_state_machine_bg":
      case "start_state_machine":
      case "start_state_machine_offline":
      case "grid_to_sm_bg":
      case "grid_to_sm_fe":
        // const actInitData = getTemplateData("activity_id_init");
        const actInitData =
          selectedSm?.table?.columns_new.filter((col) => col.type === "activity" && col.activity_type === "init") || [];
        const initFields = actInitData.find((act) => act.activity_id === params["activity_id_init"])?.items;
        allFields = initFields;
        break;

      case "sm_to_grid_bg":
      case "sm_to_grid_fe":
        if (keyName === "variable_mapping") {
          const allActData = getTemplateData("activity_id_init");
          const selectedAct = allActData.find((act) => act.activity_id === params["activity_id_init"]);
          if (!selectedAct) {
            break;
          }
          const richGridSubFields = selectedAct.items.find((field) => field.id === params["grid_id"]).sub_fields;
          if (!richGridSubFields || !richGridSubFields.length) {
            break;
          }
          const rowFields = richGridSubFields[0].sub_fields;
          if (!rowFields || !rowFields.length) {
            break;
          }
          const mappedRowFields = mapArrayToObject(rowFields);
          allFieldsObject.current = { ...allFieldsObject.current, ...mappedRowFields.result };

          allFields = rowFields;
        }
        if (keyName === "self_global_variable_mapping") {
          const { data, tableObject } = await getTableTypeData(newType, smId);
          allFieldsObject.current = { ...allFieldsObject.current, ...tableObject };
          const globaFieldData = data?.table?.columns_new.find((col) => col.activity_id === "global_fields");
          allFields = globaFieldData?.items || [];
        }
        break;

      case "send_sms_bg":
      case "send_email_bg":
      case "send_google_doc":
      case "make_html_to_pdf":
        const allKeys = Object.keys(params);
        const templateKey = allKeys.find((key) =>
          ["email_template_id", "sms_template_id", "document_template_id", "googledoc_template_id"].includes(key)
        );
        let singleData = getTemplateData(templateKey);
        const variables = singleData.find((temp) => temp.id === params[templateKey])?.variables;
        // For email, append the result fields so the sent subject/body can be captured into
        // global fields at runtime. Other job types in this shared case are unchanged.
        allFields = templateName === "send_email_bg" ? [...(variables || []), ...EMAIL_RESULT_FIELDS] : variables;
        break;
      case "send_excel_doc":
        // const allKeys1 = Object.keys(params);
        let excelData = templateObject["send_excel_doc"];
        const template = excelData.find((temp) => temp.id === params["exceldoc_template_id"]);
        const variables1 = template?.excel_variables;
        if (variables1) {
          const mappedExcelData = variables1.reduce((acc, item) => {
            // Map the main item
            acc[item.name] = item;

            // If the item has a cells array, map the cells as well
            if (item.cells && Array.isArray(item.cells)) {
              item.cells.forEach((cell) => {
                acc[cell.name] = cell;
              });
            }

            return acc;
          }, {});

          allFieldsObject.current = { ...allFieldsObject.current, ...mappedExcelData };
        }

        allFields = variables1 || [];
        break;

      case "edit_appuser_fields":
        const appuserData = await getAppUserFieldsData();
        allFields = appuserData;
        break;

      // case "update_community_user":
      // case "update_community_user_fields":
      //   const communityUserData = await getCommunityUserData();
      //   allFields = ["user_id", ...communityUserData];
      //   break;

      // case "add_community_user_to_group":
      // case "remove_community_user_to_group":
      //   allFields = ["user_id"];

      //   break;

      case "rdbms_update":
      case "rdbms_insert":
      case "postgres_update":
      case "postgres_insert":
        const tableData = templateObject["send_table"];
        const selectedTableData = tableData.find((table) => table.table_name === params.select_table);
        allFields = selectedTableData.fields || [];
        break;
      case "mongo_template_insert":
        // const currentMongoDataList = templateObject["mongo_template"] || [];
        // const currentMongoData = currentMongoDataList.find((obj) => obj.id === params.mongo_template);
        break;
      case "set_global_variables":
        const globaFieldData = selectedSm?.table?.columns_new.find((col) => col.activity_id === "global_fields");
        allFields = globaFieldData?.items || [];
        break;
      case "ocr":
        try {
          const ocrData = getTemplateData("ocr");
          templateObject["send_ocr"] = ocrData;
          const ocrTemplateId = params["ocr_template_id"];
          const selectedOcrTemplate = ocrData.find((template) => template.id === ocrTemplateId);
          if (selectedOcrTemplate) {
            const questions = selectedOcrTemplate.questions;
            const mappedOcrData = questions.reduce((acc, question) => {
              acc[question.key] = {
                // Keep only the key
                key: question.key
              };
              return acc;
            }, {});
            allFieldsObject.current = { ...allFieldsObject.current, ...mappedOcrData };
            allFields = [...Object.keys(mappedOcrData), "image_mapping"] || [];
          } else {
            allFields = [];
          }
        } catch (error) {
          console.error("Error fetching or processing OCR data:", error);
        }
        break;
      case "edit_entity_bg":
        const lookupData = getTemplateData("lookup_field_map");
        const subfields = lookupData.find((lookup) => lookup.id === params["lookup_field_map"]).sub_fields;
        const mappedSubFields = mapArrayToObject(subfields);
        allFieldsObject.current = { ...allFieldsObject.current, ...mappedSubFields.result };
        allFields = subfields;
        break;

      case "edit_sm_bg":
      case "edit_sm_by_filter_bg":
        const selectedAllActivity = data.table.columns_new.filter((obj) => obj.activity_id === "global_fields");
        const fieldList = selectedAllActivity.flatMap((obj) => obj.items);
        allFields = fieldList;
        break;

      // case "edit_sm_by_filter_bg":
      //   const selectedAll = data.table.columns_new.filter((obj) => obj.activity_id === "global_fields");
      //   const globalFields = selectedAll.flatMap((obj) => obj.items);
      //   allFields = globalFields;
      //   break;

      case "assign_roles_position_activity":
        allFields = ["role_positions"];
        break;

      case "edit_parent_sm_bg":
        const { data: newData, tableObject } = getSingleTableData(
          templateObject["light_lookup"][params.light_lookup].table_id
        );
        allFieldsObject.current = { ...allFieldsObject.current, ...tableObject };
        const globalFieldOfLightLookup = newData.table.columns_new.find((obj) => obj.activity_id === "global_fields");
        allFields = globalFieldOfLightLookup?.items || [];
        break;
      case "edit_linked_sm_bg":
        const { tableObject: o } = getSingleTableData(
          templateObject["linked_sm_lookup_id"][params.linked_sm_lookup_id].table_id
        );
        allFieldsObject.current = { ...allFieldsObject.current, ...o };
        allFields = templateObject["linked_sm_lookup_id"][params?.linked_sm_lookup_id]?.sub_fields || [];
        break;

      case "prefill_form":
        const singleActivity = data.table?.columns_new.find(
          (col) => col.type === "activity" && col.activity_id === actId
        );
        allFields = singleActivity?.items;
        break;

      case "send_email_fe":
        allFields = ["email_id"];
        break;
      case "make_call_fe":
        allFields = ["phone_number"];
        break;
      case "set_owner_bg":
      case "set_owner":
        allFields = ["app-user"];
        break;
      case "add_todo":
      case "text_notification":
        allFields = ["app-user", "notification-text", "notification-data"];
        break;
      case "register_app_user":
        allFields = ["name", "email", "password", "phone_number"];
        break;

      case "generate_page_url":
        allFields = ["instance_id", "assign_url_field"];
        break;
      case "print_detailsview_bg":
        allFields = ["store_file"];
        break;
      case "execute_sql_query":
        allFields = extractVariables(params.query);
        break;
      case "navigate_with_mapped":
      case "vapi_voice_ai":
      case "show_detailsview_popup":
      case "show_recordsview_popup":
      case "show_detailsview_in_row":
      case "show_recordsview_in_row":
        let newDataArrayTemp;
        if (editJobData) {
          newDataArrayTemp =
            editJobData.params.navigate_variable_mapping || editJobData.params.assistant_override_variables;
        } else {
          newDataArrayTemp = [];
        }
        allFields = newDataArrayTemp;
        break;
      case "grid_to_json":
        const gridPath = params.grid_path;
        if (gridPath) {
          const gridField = allFieldsObject.current[gridPath];
          if (gridField && gridField.sub_fields && gridField.sub_fields.length > 0) {
            const rowFields = gridField.sub_fields;
            const mappedRowFields = mapArrayToObject(rowFields);
            allFieldsObject.current = { ...allFieldsObject.current, ...mappedRowFields.result };
            allFields = rowFields || [];
          }
        }
        break;
      case "json_to_grid":
        let newDataArray9;
        if (editJobData) {
          newDataArray9 = editJobData.params.json_grid_variable_mapping;
        } else {
          newDataArray9 = [];
        }
        allFields = newDataArray9;
        break;
      case "make_http_request":
        const httpTemplates = templateObject["http_request_templates"];
        const templateId = params["http_template_id"];

        if (!Array.isArray(httpTemplates)) {
          console.warn("Expected 'http_request_templates' to be an array.");
          allFields = [];
          break;
        }

        if (!templateId) {
          console.warn("'http_template_id' is missing in params.");
          allFields = [];
          break;
        }

        const selectedHttpTemp = httpTemplates.find((temp) => temp.id === templateId);

        if (!selectedHttpTemp) {
          console.warn(`No HTTP template found with id '${templateId}'.`);
          allFields = [];
          break;
        }

        if (keyName === "query_variable_mapping") {
          allFields = Array.isArray(selectedHttpTemp.query_params) ? selectedHttpTemp.query_params : [];
        } else if (keyName === "body_variable_mapping") {
          if (selectedHttpTemp.body_option === "form-data") {
            if (selectedHttpTemp.body_form_data) {
              const variables = [];
              selectedHttpTemp.body_form_data.forEach((item) => {
                const v = extractVariables(item?.value || "");
                variables.push(...v);
              });
              allFields = variables;
              break;
            } else {
              allFields = [];
              break;
            }
          } else if (selectedHttpTemp.body_option === "raw-key-value") {
            if (selectedHttpTemp.body_raw_key_values) {
              const variables = [];
              selectedHttpTemp.body_raw_key_values.forEach((item) => {
                const v = extractVariables(item?.value || "");
                variables.push(...v);
              });
              allFields = variables;
              break;
            } else {
              allFields = [];
              break;
            }
          } else {
            const bodyDefinition = selectedHttpTemp.body_data_definition || "";
            allFields = extractVariables(bodyDefinition);
          }
        } else if (keyName === "header_variable_mapping") {
          const headerParams = selectedHttpTemp.header_parameters;
          if (!Array.isArray(headerParams)) {
            console.warn("'header_parameters' should be an array.");
            allFields = [];
            break;
          }

          let variables = [];
          headerParams.forEach((h) => {
            const sv = extractVariables(h?.value || "");
            variables = [...variables, ...sv];
          });
          allFields = variables;
        } else if (keyName === "output_variable_mapping") {
          const outputVariables = selectedHttpTemp.http_output_variable_bindings || [];
          let variables = [];
          outputVariables.forEach((o) => {
            const ov = extractVariables(o?.path || "");
            variables = [...variables, ...ov];
          });
          allFields = variables;
        } else if (keyName === "url_variable_mapping") {
          allFields = extractVariables(selectedHttpTemp.url || "");
        } else {
          console.warn(`Unsupported keyName '${keyName}' for make_http_request.`);
          allFields = [];
        }

        break;

      case "schedule_activity_bg":
        const scheduledActivity = data.table.columns_new.find((col) => col.activity_id === params.system_activity_id);
        allFields = scheduledActivity?.items || [];
        allFields = [
          { display: "Scheduled Date", id: "scheduled_date" },
          { display: "Scheduled Time", id: "scheduled_time" },
          { display: "Frequency", id: "frequency" },
          ...allFields
        ];
        break;
      case "edit_self_entity_bg":
        let allActivities = [];
        if (data.table.table_type === "entity") {
          const allAct = data.table?.columns_new.filter((col) => col.type === "activity").map((col) => col.items);
          allActivities = allAct.flat();
        }
        allFields = allActivities;
        break;
      // case "create_community_user":
      //   allFields = ["name", "mobile", "email"];
      //   break;
      default:
        break;
    }

    let mapping =
      templateName === "navigate_with_mapped" ||
      templateName === "vapi_voice_ai" ||
      templateName === "json_to_grid" ||
      templateName === "show_detailsview_popup" ||
      templateName === "show_recordsview_popup" ||
      templateName === "show_recordsview_in_row" ||
      templateName === "show_detailsview_in_row"
        ? allFields
        : filterMapping(newObj, allFields);
    return mapping?.filter((item) => !item.key.includes("activity_performed"));
  };

  const settingMapping = async () => {
    let newObj = {};
    if (keyName) {
      const mappingData = await makeParamsArray(newObj, jobTemplateName);
      setParams({ ...params, [keyName]: mappingData });
    }
  };

  useEffect(() => {
    // if (keyName === "body_variable_mapping") return;
    settingMapping();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);

  return (
    <>
      <VariableMapping
        keyName={keyName}
        params={params}
        setParams={setParams}
        handleParamsData={(newParams, key) => handleParamsData(newParams, key, keyName)}
        smId={smId}
        allFieldsObject={allFieldsObject}
        isReadOnly={isReadOnly}
        preRequirements={preRequirements}
        jobTemplateName={jobTemplateName}
      />
    </>
  );
};

const VariableMapping = ({
  keyName,
  params,
  handleParamsData,
  allFieldsObject,
  smId,
  isReadOnly,
  jobTemplateName,
  // folderId = "",
  preRequirements
}) => {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const initModalState = {
    isOpen: false,
    fieldId: "",
    index: ""
  };
  const [modalState, setModalState] = useState(initModalState);
  const openModal = (index, id, type) => setModalState({ isOpen: true, fieldId: id, index, type });
  const closeModal = () => setModalState(initModalState);
  const [fetchingToken, setFetchingToken] = useState(true);
  const [listOfFromToken, setListOfFromToken] = useState([]);
  const [templateTreeData, setTemplateTreeData] = useState([]);

  const singleTableRowUpdata = (index, key, value) => {
    let copyData = JSON.parse(JSON.stringify(params));
    const newData = copyData[keyName].map((data, i) => {
      if (index === i) {
        return { ...data, value: key === "type" ? "" : data.value, [key]: value };
      }
      return data;
    });
    copyData = { ...copyData, [keyName]: newData };
    // handleParamsData(keyName, newData)
    handleParamsData(copyData, keyName);
  };
  const removeMappedValue = (index) => {
    let copyData = JSON.parse(JSON.stringify(params));
    const newData = copyData[keyName].map((data, i) => {
      if (i === index) {
        if (data.sub_variable_mapping) {
          return { ...data, value: "", sub_variable_mapping: [] };
        } else {
          return { ...data, value: "" };
        }
      }
      return data;
    });
    // handleParamsData(keyName, newData)
    copyData = { ...copyData, [keyName]: newData };

    handleParamsData(copyData, keyName);
  };
  const callbackFunction = (field) => {
    singleTableRowUpdata(modalState.index, "value", field.id);
    closeModal();
  };
  const handleSelectTemplateOutputVariable = (variable) => {
    singleTableRowUpdata(modalState.index, "value", variable);
    closeModal();
  };

  const getParamsKey = (keyFielName, key, index) => {
    const fieldData = allFieldsObject?.current?.[key];
    switch (keyName) {
      case "navigate_variable_mapping":
        if (fetchingToken) {
          return null;
        }
        return (
          <>
            {!isValidObjectId(key) && <label>{key}</label>}
            <FromTokenDropdown
              selected={listOfFromToken.find((o) => o.id === key)}
              onSelect={(opt) => singleTableRowUpdata(index, "key", opt.id)}
              options={listOfFromToken}
              setOptions={setListOfFromToken}
            />
          </>
        );
      case "assistant_override_variables":
      case "json_grid_variable_mapping":
        return (
          <Input
            autoFocus={true}
            type="text"
            value={key}
            onChange={(e) => singleTableRowUpdata(index, "key", e.target.value)}
          />
        );
      default:
        return (
          <span
            className="table_key"
            {...getToolTipAttributes(
              fieldData
                ? `${fieldData.prefix ? fieldData.prefix + "." : ""}${fieldData.display || ""}`
                : keyFielName || ""
            )}
          >
            {keyFielName}
          </span>
        );
    }
  };

  const getDataTypeInput = (type, value, index) => {
    switch (type) {
      case "mapped":
      case "logged_in_user":
      case "mapped_http_response":
        const fieldData = allFieldsObject?.current?.[value];
        return (
          <div
            onClick={() => openModal(index, value, type)}
            {...getToolTipAttributes(
              fieldData
                ? fieldData.path && fieldData.name
                  ? `${fieldData.path}.${fieldData.name}`
                  : `${fieldData.prefix ? fieldData.prefix + "." : ""}${fieldData.display || ""}`
                : ""
            )}
          >
            {value === "" ? "select field" : fieldData?.display || fieldData?.name || "Unknown field"}
          </div>
        );
      case "hardcoded":
      case "json_key":
        return (
          <Input type="text" value={value} onChange={(e) => singleTableRowUpdata(index, "value", e.target.value)} />
        );
      // case "date_format":
      //   return (
      //     <input type="date" value={value} onChange={(e) => singleTableRowUpdata(index, "value", e.target.value)} />
      //   );
      case "time_format":
        return (
          <Input type="time" value={value} onChange={(e) => singleTableRowUpdata(index, "value", e.target.value)} />
        );
      case "logic":
        return <Textarea value={value} onChange={(e) => singleTableRowUpdata(index, "value", e.target.value)} />;
      case "dropdown":
        return (
          <select
            className="builder_input"
            value={value}
            onChange={(e) => singleTableRowUpdata(index, "value", e.target.value)}
          >
            <option value=""></option>
            <option value="once">Once</option>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="bi-weekly">Bi-weekly</option>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
          </select>
        );
      default:
        break;
    }
  };
  useEffect(() => {
    setFetchingToken(true);
    const fetchAllFromToken = async () => {
      try {
        const { data } = await axiosInstance.get("/from_token");
        // if (jobTemplateName === "set_global_variables") {
        const { data: httpData } = await axiosInstance.get("/http-request-templates");
        const { treeData, mapObject } = getTreedataForOutputTemplate(httpData);
        setTemplateTreeData(treeData);
        allFieldsObject.current = { ...allFieldsObject.current, ...mapObject };
        // }
        setListOfFromToken(data);
        setFetchingToken(false);
      } catch (error) {
        setListOfFromToken([]);
      }
    };
    fetchAllFromToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (params[keyName] === "") return null;
  if (isReadOnly) {
    return (
      <VariableMappingReadOnly
        params={params[keyName] || []}
        allFieldsObject={allFieldsObject}
        jobTemplateName={jobTemplateName}
        keyName={keyName}
      />
    );
  }

  const newFieldsObject = (key) => {
    const typeKey = jobTemplateName === "send_excel_doc" ? "cells" : "sub_fields";

    const subFields =
      allFieldsObject.current[key]?.field_type === "rich-grid"
        ? allFieldsObject.current[key]?.[typeKey][0].sub_fields
        : allFieldsObject.current[key]?.[typeKey];

    const { result: mappedSubFields } = mapArrayToObject(subFields);

    return { current: { ...mappedSubFields, ...allFieldsObject.current } };
  };
  return (
    <>
      <div className="builder_form">
        <label className="builder_label">{getLabelNameForTheJobMapping(keyName)}</label>
        {jobTemplateName === "set_global_variables" && (
          <SetGlobalVariablesPlugin
            keyName={keyName}
            params={params}
            allFieldsObject={allFieldsObject}
            handleParamsData={handleParamsData}
          />
        )}
        <table className="post_activity_sidebar_table">
          <thead>
            <tr>
              <th>Key</th>
              <th>Type</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {params[keyName]?.map((data, index) => (
              <>
                <RenderSingleMapping
                  key={data.key}
                  allFieldsObject={allFieldsObject}
                  data={data}
                  index={index}
                  getParamsKey={getParamsKey}
                  singleTableRowUpdata={singleTableRowUpdata}
                  keyName={keyName}
                  removeMappedValue={removeMappedValue}
                  getDataTypeInput={getDataTypeInput}
                  // modifiedParams={modifiedParams}
                  handleParamsData={handleParamsData}
                  smId={smId}
                  isReadOnly={isReadOnly}
                  newFieldsObject={newFieldsObject}
                  jobTemplateName={jobTemplateName}
                  preRequirements={preRequirements}
                />
              </>
            ))}
          </tbody>
        </table>
      </div>

      <BuilderModal isOpen={modalState.isOpen} onClose={closeModal} modalName="Add Field">
        {jobTemplateName === "set_global_variables" || modalState.type === "mapped_http_response" ? (
          <Tree
            explorerData={templateTreeData}
            setExplorerData={setTemplateTreeData}
            folderData={templateTreeData}
            callbackFunction={handleSelectTemplateOutputVariable}
            showCollapseButton={true}
          />
        ) : (
          <TableTreeModal callbackFunction={callbackFunction} tableId={smId} selectedFile={modalState.fieldId} />
        )}
      </BuilderModal>
    </>
  );
};

const RenderSingleMapping = ({
  allFieldsObject,
  data,
  index,
  getParamsKey,
  singleTableRowUpdata,
  keyName,
  removeMappedValue,
  getDataTypeInput,
  // modifiedParams,
  handleParamsData,
  smId,
  isReadOnly,
  newFieldsObject,
  jobTemplateName,
  preRequirements
}) => {
  const keyFielName =
    allFieldsObject.current[data?.key]?.display ||
    allFieldsObject.current[data?.key]?.label ||
    allFieldsObject.current[data?.key]?.name ||
    allFieldsObject.current[data?.key]?.field_type ||
    data?.key ||
    "";

  const fieldTypeIcon = allFieldsObject.current[data?.key]?.field_type || "";
  const icon = getFieldIcon(fieldTypeIcon);

  const { type, value, key } = data;
  // Email result rows (_RESULT_SUBJECT / _RESULT_BODY) are always mapped to a global field.
  const isResultField = jobTemplateName === "send_email_bg" && EMAIL_RESULT_FIELDS.includes(key);
  const [fieldType, setFieldType] = useState("");
  const [valueFieldType, setValueFieldType] = useState("");

  const modifiedParams = (data, key) => {
    // Use existing sub_variable_mapping if it exists, otherwise initialize to empty array
    const newParams = {
      ...data,
      sub_variable_mapping: data.sub_variable_mapping || []
    };
    const typeKey = jobTemplateName === "send_excel_doc" ? "cells" : "sub_fields";

    const subFields =
      allFieldsObject.current[key]?.field_type === "rich-grid"
        ? allFieldsObject.current[key]?.[typeKey][0].sub_fields
        : allFieldsObject.current[key]?.[typeKey];

    // If subFields exist and sub_variable_mapping is empty, map the new values
    if (subFields && newParams.sub_variable_mapping.length === 0) {
      newParams.sub_variable_mapping = subFields.map((field) => ({
        key: field.id || field?.name,
        type: getDefaultTypeOfMapping(field.field_type, jobTemplateName),
        value: ""
      }));
    }

    return newParams;
  };

  const isSubMapping =
    (fieldType === "recordset-list" && valueFieldType === "recordset-list") ||
    (fieldType === "grid" && valueFieldType === "recordset-list") ||
    (fieldType === "recordset-list" && valueFieldType === "grid") ||
    (fieldType === "grid" && valueFieldType === "grid") ||
    (fieldType === "rich-grid" && valueFieldType === "grid");
  const typeKey = jobTemplateName === "send_excel_doc" ? "type" : "field_type";

  useEffect(() => {
    if (data.key === "scheduled_date" || data.key === "scheduled_time" || data.key === "frequency") {
      setFieldType(data.key);
    } else {
      let fieldType = allFieldsObject.current?.[data?.key]?.[typeKey] || "";
      let valueType = allFieldsObject.current?.[data?.value]?.field_type || "";
      setFieldType(fieldType);
      setValueFieldType(valueType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allFieldsObject.current?.[data?.value]?.[typeKey]]);
  return (
    <>
      <React.Fragment key={key + index}>
        {!keyFielName.includes("Activity Performed") ? (
          <>
            <tr className={hasValue(data) ? "highlighted-row" : ""}>
              <td className="activity_table_key">
                <div className="d_flex g_8" style={{ color: !isValidObjectId(data.key || "") ? "#3a1890" : "black" }}>
                  <MaterialIcon name={icon} className="font_size_xlarge" />
                  {getParamsKey(keyFielName, key, index)}
                </div>
              </td>
              <td className="activity_table_select">
                <select
                  className="builder_input"
                  value={isResultField ? "mapped" : data.type}
                  disabled={isResultField}
                  onChange={(e) => singleTableRowUpdata(index, "type", e.target.value)}
                >
                  {isResultField ? <option value="mapped">Mapped</option> : getTypeOptions(keyName, fieldType)}
                </select>
              </td>
              <td className="activity_table_value">
                <div className="selected_value_items">
                  <div className="activity_selected_value_item">{getDataTypeInput(type, value, index)}</div>
                  <div>
                    {value && (
                      <MaterialIcon name="delete" className="delete_icon" onClick={() => removeMappedValue(index)} />
                    )}
                  </div>
                </div>
              </td>
            </tr>
            {isSubMapping && (
              <tr className={hasValue(data) ? "highlighted-row" : ""}>
                <td colSpan="3" style={{ padding: "12px 24px", backgroundColor: "#f9f9f9" }}>
                  <VariableMapping
                    keyName="sub_variable_mapping"
                    params={modifiedParams(data, key)}
                    handleParamsData={handleParamsData}
                    allFieldsObject={newFieldsObject(key)}
                    smId={smId}
                    isReadOnly={isReadOnly}
                    jobTemplateName={jobTemplateName}
                    folderId={value}
                    preRequirements={preRequirements}
                  />
                </td>
              </tr>
            )}
          </>
        ) : null}
      </React.Fragment>
    </>
  );
};

const getTreedataForOutputTemplate = (data) => {
  const mapObject = {};
  const treeDatadata = data
    .map((item) => {
      try {
        const { id, name } = item;
        const folder = fileFolderConfig.getFolderConfig(id, name, "", false, false);

        folder.items = (item.http_output_variable_bindings || [])
          .map((output) => {
            try {
              const { id, name } = output;
              mapObject[id] = output;
              return fileFolderConfig.getFileConfig(id, name, "", false, false);
            } catch (e) {
              console.error("Output mapping error:", e);
              return null;
            }
          })
          .filter(Boolean);
        return folder;
      } catch (e) {
        console.error("Item mapping error:", e);
        return null;
      }
    })
    .filter(Boolean);
  return { mapObject, treeData: treeDatadata };
};

//helper function to check the if the row has value in the Value column
const hasValue = (data) => {
  return data.value && data.value.toString().trim() !== "";
};

export default GetVariableMapping;
export { VariableMapping };
